import { ServiceType } from '@wix/ambassador-bookings-services-v2-service/types';
import { legacyToSettingsFeatures } from './legacyToSettingsFeatures';
export const isFeatureEnabled = _ref => {
  var _asSettings$key;
  let {
    activeFeatures,
    service
  } = _ref;
  const asSettings = 'bookingsAppointments' in activeFeatures ? activeFeatures : legacyToSettingsFeatures(activeFeatures);
  const keyByType = {
    [ServiceType.APPOINTMENT]: 'bookingsAppointments',
    [ServiceType.COURSE]: 'bookingsCourses',
    [ServiceType.CLASS]: 'bookingsGroups'
  };
  const key = keyByType[service.type];
  if (!key) {
    return true;
  }
  return ((_asSettings$key = asSettings[key]) == null ? void 0 : _asSettings$key.enabled) ?? true;
};
//# sourceMappingURL=activeFeature.js.map